import { render } from "./privacy.vue?vue&type=template&id=bfecb38e"
const script = {}

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__